import React from 'react';
import '../../../src/styles/traditionalprocessfaq.scss';

export default function TraditionalprocessfaqRealtor(props) {
	return (
		<div>
			<div className="pl-3">
				The Trade-In Mortgage™ is more convenient, less stressful, and often cheaper than the traditional process. Using The Trade-In Mortgage™, you will be able to:
			</div>
			<br />
			<div className="how-content-traditionalprocessfaq">
				<ul className="pl-3">
					<li><b>Win with {(props?.partner?.url_path === "jw&!$329654" || props?.partner?.url_path === "jasonwalter") ? 'competitive' : 'non-contingent'} offers that function like all-cash offers.</b>&nbsp;
						We will help you submit {(props?.partner?.url_path === "jw&!$329654" || props?.partner?.url_path === "jasonwalter") ? '' : 'non-contingent'} offers on new home prospects, that aren't contigent on the sale of your current home, positioning you as a competitive buyer in today’s increasingly crowded real estate market. Importantly, we are often able to leverage {(props?.partner?.url_path === "jw&!$329654" || props?.partner?.url_path === "jasonwalter") ? 'these' : 'non-contingent'} offers to negotiate a lower purchase price.
					</li>
				</ul>
			</div>
			<div className="how-content-traditionalprocessfaq">
				<ul className="pl-3">
					<li>
						<b>Buy and move into your new home before you sell your original one.</b>&nbsp;
						This allows you to avoid the stress of trying to time the sale of your original home with the purchase of your new home, submitting contingent offers, or moving into a short-term rental while you look for a new home.
					</li>
				</ul>
			</div>
			<div className="how-content-traditionalprocessfaq">
				<ul className="pl-3">
					<li>
						<b>Prep your original home for sale after you have moved out.</b>&nbsp;
						This allows you to avoid the hassle of constantly cleaning and organizing your home to maintain show-readiness while you are living in it. Furthermore, we can help you take advantage of the vacancy to make repairs and stage your original home so that it sells for maximum value.
					</li>
				</ul>
			</div>
			<div className="how-content-traditionalprocessfaq">
				<ul className="pl-3">
					<li>
						<b>Experience cost savings.</b>&nbsp;
						For a small fee, you will move forward with a conventional loan on your new home without incurring the costs of moving twice, short-term rentals, double mortgage payments, and/or private mortgage insurance.
					</li>
				</ul>
			</div>
		</div>
	)
}